import { setTheme } from "theme/default/setTheme";

export const setColor_rgba_0_0_0_95 = setTheme(({ theme }) => `color: ${theme.colors.color_rgba_0_0_0_95}`);
